import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { LoggedInUserDto } from '../../interfaces/loggedInUserDto';
import { Constants, Routes } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class MfaVerificationGuard  {
  loggedInUserDetails: LoggedInUserDto;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.loggedInUserDetails = this.authenticationService.GetLoggedInUserDetails();
    if (this.loggedInUserDetails?.type.toLowerCase() === Constants.EXTERNAL_USER) {
      if (!this.loggedInUserDetails.isMfaEnabled || 
        (this.authenticationService.IsMfaVerified() && this.authenticationService.IsAuthenticated())) {
        return true;
      }
    }
    else if (this.loggedInUserDetails?.type.toLowerCase() === Constants.INTERNAL_USER && 
      this.authenticationService.IsMfaVerified() && this.authenticationService.IsAuthenticated()) {
      return true;
    }
    this.router.navigate([Routes.MFA_VERIFICATION_ROUTE]);
    return false;
  }
}